// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCfu2tlUIMTlcCz96a94kyW7giRnBhnwqI",
    authDomain: "solar-21-4128c.firebaseapp.com",
    databaseURL: "https://solar-21-4128c.firebaseio.com",
    projectId: "solar-21-4128c",
    storageBucket: "solar-21-4128c.appspot.com",
    messagingSenderId: "935805059286",
    appId: "1:935805059286:web:3d10db221f9147c8"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
